export class GetBorrowerSidebarCards {
  static readonly type = '[BorrowerSidebar] GetBorrowerSidebarCards';
  constructor() {}
}

export class UpdateCardsStorage {
  static readonly type = '[BorrowerSidebar] UpdateCardsOrderStorage';
  constructor() {}
}

export class UpdateExpandedStatus {
  static readonly type = '[BorrowerSidebar] UpdateExpandedStatus';
  constructor(
    public name: string,
    public expanded: boolean,
  ) {}
}
